// TEST DATA for the fit-check embed pages, until the brand-scoped embed
// endpoints are deployed (api/embed.js decides when this is used).
//
// Deterministic per brand: a seeded generator builds ~120 days of history
// once, and every "endpoint" below is a pure query over it, so the overview,
// the visitors list and the filters always agree with each other.
//
// The shapes are the contract in api/embed.js, nothing more.

const DAYS = 120;
const PAGE_SIZE = 25;

const img = (id) => `https://images.unsplash.com/photo-${id}?w=400&h=400&fit=crop&auto=format&q=70`;

// [title, handle, unsplash id, popularity, price in HUF]
const PRODUCTS = [
  ['Organic Cotton Crew Tee – White', 'organic-cotton-crew-tee-white', '1521572163474-6864f9cf17ab', 1.6, 12990],
  ['Biker Leather Jacket – Black', 'biker-leather-jacket-black', '1551028719-00167b16eac5', 1.4, 79990],
  ['Satin Bomber Jacket – Rust', 'satin-bomber-jacket-rust', '1591047139829-d91aecb6caea', 1.0, 39990],
  ['Graphic Print Tee – Sand', 'graphic-print-tee-sand', '1576566588028-4147f3842f27', 0.9, 10990],
  ['Essential Logo Tee – Black', 'essential-logo-tee-black', '1583743814966-8936f5b7be1a', 1.1, 9990],
  ['Relaxed Cuffed Jogger – Blush', 'relaxed-cuffed-jogger-blush', '1594633312681-425c7b97ccd1', 0.7, 17990],
  ['Flowing Maxi Dress – Scarlet', 'flowing-maxi-dress-scarlet', '1595777457583-95e059d581b8', 1.5, 34990],
  ['Straight Leg Jeans – Raw Indigo', 'straight-leg-jeans-raw-indigo', '1624378439575-d8705ad7ae80', 1.2, 24990],
  ['Heavyweight Hoodie – Heather Grey', 'heavyweight-hoodie-heather-grey', '1556821840-3a63f95609a7', 1.3, 22990],
  ['Crewneck Sweatshirt – Off-White', 'crewneck-sweatshirt-off-white', '1620799140408-edc6dcb6d633', 0.8, 18990],
  ['Top Handle Bag – Cherry Red', 'top-handle-bag-cherry-red', '1584917865442-de89df76afd3', 0.6, 44990],
  ['Oversized Knit Jumper – Tangerine', 'oversized-knit-jumper-tangerine', '1578587018452-892bacefd3f2', 0.9, 26990],
  ['Slim Fit Blazer – Navy', 'slim-fit-blazer-navy', '1617137968427-85924c800a22', 0.7, 54990],
  ['Classic Poplin Shirt – White', 'classic-poplin-shirt-white', '1598033129183-c4f50c736f10', 0.8, 16990],
  ['Chambray Dot Shirt – Light Blue', 'chambray-dot-shirt-light-blue', '1596755094514-f87e34085b2c', 0.5, 15990],
  ['Wrap Midi Dress – Poppy', 'wrap-midi-dress-poppy', '1572804013309-59a88b7e92f1', 1.1, 29990],
  ['Slub Jersey Tee – Dusty Blue', 'slub-jersey-tee-dusty-blue', '1564584217132-2271feaeb3c5', 0.6, 8990],
  ['Denim Trucker Jacket – Cord Collar', 'denim-trucker-jacket-cord-collar', '1611312449408-fcece27cdbb7', 1.0, 32990],
];

export const AVATARS = [
  '1531746020798-e6953c6e8e04', '1524504388940-b1c1722653e1', '1529626455594-4ff0802cfb7e', '1504257432389-52343af06ae3',
  '1519085360753-af0119f7cbe7', '1531123897727-8f129e1688ce', '1527980965255-d3b416303d12', '1547425260-76bcadfb4f2c',
  '1552058544-f2b08422138a', '1573496359142-b8d87734a5a2', '1580489944761-15a19d654956', '1599566150163-29194dcaad36',
  '1544005313-94ddf0286df2', '1494790108377-be9c29b29330', '1438761681033-6461ffad8d80', '1500648767791-00dcc994a43e',
  '1534528741775-53994a69daeb', '1506794778202-cad84cf45f1d', '1517841905240-472988babdf9', '1539571696357-5a69c17a67c6',
  '1488426862026-3ee34a7d66df', '1507003211169-0a1dd7228f2d',
].map((id) => `https://images.unsplash.com/photo-${id}?w=96&h=96&fit=crop&crop=faces&auto=format&q=70`);

export const FIRST_NAMES = [
  'zsofi', 'bence', 'lilla', 'marci', 'dora', 'nora', 'kristof', 'anna', 'gergo', 'reka', 'petra', 'adam', 'eszter',
  'viki', 'balazs', 'fanni', 'tamas', 'judit', 'levente', 'boglarka', 'emma', 'lukas', 'sofia', 'maya', 'oliver',
  'clara', 'noah', 'hanna', 'mila', 'jakub', 'lena', 'daniel', 'ivett', 'patrik', 'kinga', 'dominik', 'szonja',
  'mate', 'timea', 'vivien', 'csenge', 'kata', 'zoli', 'luca', 'aron', 'flora', 'barbi', 'gabor', 'rita', 'blanka',
  'milan', 'orsi', 'hugo', 'janka', 'botond', 'cintia', 'vince', 'laura', 'mark', 'eva',
];
export const SUFFIXES = ['.styles', '_ootd', '.wears', '.fits', '.daily', '.closet', '.looks', '_k', '.b', '_m', '.minimal', '.vintage', '.denim', '', '_', '.mode'];

// mulberry32 — small, fast, seedable.
export function rng(seed) {
  let a = seed >>> 0;
  return function next() {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function dayKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function weighted(next, items, weightOf) {
  const total = items.reduce((s, it) => s + weightOf(it), 0);
  let r = next() * total;
  for (const it of items) {
    r -= weightOf(it);
    if (r <= 0) return it;
  }
  return items[items.length - 1];
}

const PHOTO_COUNTS = [3, 6, 9, 3, 6, 9, 1, 2, 4, 5, 7, 8];

function build(brandId, now) {
  const next = rng(hash(String(brandId || 'brand')));
  const products = PRODUCTS.map(([title, handle, imageId, weight, price], i) => ({
    shopifyProductId: String(8123456700000 + i * 7919 + (hash(handle) % 997)),
    handle,
    title,
    imageUrl: img(imageId),
    weight,
    price,
    // Some products simply suit more people than others.
    compatBase: 52 + Math.round(next() * 30),
  }));
  // Visitors join over time; a sign-in is a new account about 40% of the time.
  const users = [];
  const taken = new Set();
  let faces = 0;
  function newUser() {
    let username = FIRST_NAMES[Math.floor(next() * FIRST_NAMES.length)] + SUFFIXES[Math.floor(next() * SUFFIXES.length)];
    while (taken.has(username) || username.endsWith('_')) username += Math.floor(next() * 90 + 10);
    taken.add(username);
    const user = {
      id: `mock-user-${users.length + 1}`,
      username,
      avatarUrl: next() < 0.6 ? AVATARS[faces++ % AVATARS.length] : null,
    };
    users.push(user);
    return user;
  }
  for (let i = 0; i < 25; i += 1) newUser();
  // Who already follows the brand: a follow happens once per user.
  const following = new Set();

  const days = [];
  const items = [];
  const push = (user, event, at, onProduct, extra = {}) => {
    if (at > now) return;
    items.push({
      id: `mock-${items.length + 1}`,
      user,
      event,
      product: onProduct,
      photosUploaded: extra.photosUploaded ?? null,
      compatibility: extra.compatibility ?? null,
      ...(extra.matched !== undefined ? { matched: extra.matched } : {}),
      ...(extra.quantity ? { quantity: extra.quantity } : {}),
      ...(extra.orderValue ? { orderValue: extra.orderValue } : {}),
      occurredAt: at.toISOString(),
    });
  };
  // A cart, and sometimes the purchase after it. `matched`: the visitor
  // viewed the matching for this product before (within 30 days).
  const shop = (user, at, product, matched, buyRate) => {
    const quantity = next() < 0.85 ? 1 : 2;
    push(user, 'add_to_cart', at, product, { matched, quantity });
    if (next() < buyRate) {
      push(user, 'purchase', new Date(at.getTime() + (6 + next() * 80) * 60000), product, {
        matched,
        quantity,
        orderValue: { amount: product.price * quantity, currency: 'HUF' },
      });
    }
  };

  for (let back = DAYS - 1; back >= 0; back -= 1) {
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() - back);
    const weekend = date.getDay() === 0 || date.getDay() === 6;
    // Gentle growth over the window, a weekend bump, day-to-day noise.
    const trend = 0.75 + 0.5 * ((DAYS - back) / DAYS);
    const dayFactor = trend * (weekend ? 1.22 : 1) * (0.82 + next() * 0.36);
    const perProduct = {};

    for (const p of products) {
      const impressions = Math.round(p.weight * 34 * dayFactor * (0.7 + next() * 0.6));
      const clicks = Math.round(impressions * (0.045 + next() * 0.04));
      // Carts / purchases the pixel saw from everyone else on the page
      // (no Outfino account in sight, so never matched, never listed).
      const carts = Math.round(impressions * (0.016 + next() * 0.012));
      const purchases = Math.round(carts * (0.25 + next() * 0.12));
      perProduct[p.shopifyProductId] = { impressions, clicks, carts, purchases };
    }

    // Journeys: a click that went on to a sign-in, then (mostly) photos and
    // the product matching.
    const totalClicks = Object.values(perProduct).reduce((s, x) => s + x.clicks, 0);
    const journeys = Math.max(0, Math.round(totalClicks * (0.3 + next() * 0.12)));
    for (let j = 0; j < journeys; j += 1) {
      const product = weighted(next, products, (p) => perProduct[p.shopifyProductId].clicks + 0.2);
      const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 8 + Math.floor(next() * 15), Math.floor(next() * 60), Math.floor(next() * 60));
      if (start > now) continue;
      const isNew = next() < 0.4;
      const user = isNew ? newUser() : users[Math.floor(next() * users.length)];
      push(user, isNew ? 'signup' : 'login', start, product);
      // ~25% of the signed-in visitors follow the brand from the frame.
      if (!following.has(user.id) && next() < 0.25) {
        following.add(user.id);
        push(user, 'follow', new Date(start.getTime() + (1 + next() * 20) * 60000), product);
      }

      if (next() < 0.68) {
        const photos = PHOTO_COUNTS[Math.floor(next() * PHOTO_COUNTS.length)];
        push(user, 'upload', new Date(start.getTime() + (2 + next() * 5) * 60000), product, { photosUploaded: photos });
      }
      if (next() < 0.82) {
        // Often the match they open is a different product of the shop.
        const viewed = next() < 0.35 ? weighted(next, products, (p) => p.weight) : product;
        const compatibility = Math.max(18, Math.min(98, Math.round(viewed.compatBase + (next() - 0.5) * 36)));
        const seen = new Date(start.getTime() + (8 + next() * 10) * 60000);
        push(user, 'match_view', seen, viewed, { compatibility });
        // ~13% of the matching viewers put that product in the cart — right
        // away or within a few days — and ~35% of those buy it.
        if (next() < 0.13) shop(user, new Date(seen.getTime() + (3 + next() * (next() < 0.6 ? 40 : 4 * 1440)) * 60000), viewed, true, 0.35);
      }
      // Now and then a signed-in visitor buys something else, unmatched.
      if (next() < 0.05) {
        const other = weighted(next, products, (p) => p.weight);
        if (other !== product) shop(user, new Date(start.getTime() + (20 + next() * 120) * 60000), other, false, 0.3);
      }
    }

    days.push({ date: dayKey(date), perProduct });
  }

  items.sort((a, b) => (a.occurredAt < b.occurredAt ? 1 : -1));
  const strip = ({ weight, compatBase, price, ...p }) => p;
  return {
    products: products.map(strip),
    days,
    items: items.map((it) => ({ ...it, product: strip(it.product) })),
  };
}

const cache = new Map();
function dataset(brandId) {
  const today = dayKey(new Date());
  const cacheKey = `${brandId}:${today}`;
  if (!cache.has(cacheKey)) cache.set(cacheKey, build(brandId, new Date()));
  return cache.get(cacheKey);
}

const inRange = (key, from, to) => (!from || key >= from) && (!to || key <= to);

export function mockOverview(brandId, { from, to } = {}) {
  const data = dataset(brandId);
  const days = data.days.filter((d) => inRange(d.date, from, to));
  // occurredAt is UTC; the day buckets are local, so items are keyed by local day.
  const itemDay = (it) => dayKey(new Date(it.occurredAt));
  const items = data.items.filter((it) => inRange(itemDay(it), from, to));

  const daily = days.map((d) => {
    const row = { date: d.date, impressions: 0, clicks: 0, signups: 0, logins: 0, matchViews: 0, photosUploaded: 0, addToCarts: 0, purchases: 0, follows: 0 };
    Object.values(d.perProduct).forEach((x) => {
      row.impressions += x.impressions;
      row.clicks += x.clicks;
      row.addToCarts += x.carts;
      row.purchases += x.purchases;
    });
    return row;
  });
  const byDate = Object.fromEntries(daily.map((r) => [r.date, r]));

  const perProduct = Object.fromEntries(
    data.products.map((p) => [p.shopifyProductId, {
      ...p, impressions: 0, clicks: 0, signups: 0, matchViews: 0, photosUploaded: 0, compat: [],
      addToCarts: 0, addToCartsMatched: 0, purchases: 0, purchasesMatched: 0, revenue: 0, follows: 0,
    }])
  );
  days.forEach((d) => Object.entries(d.perProduct).forEach(([id, x]) => {
    perProduct[id].impressions += x.impressions;
    perProduct[id].clicks += x.clicks;
    perProduct[id].addToCarts += x.carts;
    perProduct[id].purchases += x.purchases;
  }));

  let uploadSessions = 0;
  let addToCartsMatched = 0;
  let purchasesMatched = 0;
  let revenue = 0;
  items.forEach((it) => {
    const row = byDate[itemDay(it)];
    const p = perProduct[it.product.shopifyProductId];
    if (it.event === 'signup') { if (row) row.signups += 1; p.signups += 1; }
    if (it.event === 'login' && row) row.logins += 1;
    if (it.event === 'match_view') { if (row) row.matchViews += 1; p.matchViews += 1; p.compat.push(it.compatibility); }
    if (it.event === 'upload') {
      uploadSessions += 1;
      if (row) row.photosUploaded += it.photosUploaded;
      p.photosUploaded += it.photosUploaded;
    }
    if (it.event === 'follow') { if (row) row.follows += 1; p.follows += 1; }
    if (it.event === 'add_to_cart') {
      if (row) row.addToCarts += 1;
      p.addToCarts += 1;
      if (it.matched) { addToCartsMatched += 1; p.addToCartsMatched += 1; }
    }
    if (it.event === 'purchase') {
      if (row) row.purchases += 1;
      p.purchases += 1;
      if (it.matched) {
        purchasesMatched += 1;
        p.purchasesMatched += 1;
        revenue += it.orderValue.amount;
        p.revenue += it.orderValue.amount;
      }
    }
  });

  const sum = (k) => daily.reduce((s, r) => s + r[k], 0);
  const totals = {
    impressions: sum('impressions'),
    clicks: sum('clicks'),
    signups: sum('signups'),
    logins: sum('logins'),
    matchViews: sum('matchViews'),
    uploadSessions,
    photosUploaded: sum('photosUploaded'),
    uniqueVisitors: Math.round(sum('impressions') * 0.61),
    addToCarts: sum('addToCarts'),
    addToCartsMatched,
    purchases: sum('purchases'),
    purchasesMatched,
    revenueMatched: [{ currency: 'HUF', amount: revenue }],
    follows: sum('follows'),
  };
  const ratio = (a, b) => (b ? a / b : null);
  const topProducts = Object.values(perProduct)
    .filter((p) => p.impressions > 0)
    .map(({ compat, revenue: rev, ...p }) => ({
      ...p,
      revenueMatched: [{ currency: 'HUF', amount: rev }],
      avgCompatibility: compat.length ? Math.round(compat.reduce((s, x) => s + x, 0) / compat.length) : null,
    }))
    .sort((a, b) => b.signups - a.signups || b.matchViews - a.matchViews);

  return {
    totals,
    rates: {
      clickThrough: ratio(totals.clicks, totals.impressions),
      signIn: ratio(totals.signups + totals.logins, totals.clicks),
      matchView: ratio(totals.matchViews, totals.signups + totals.logins),
    },
    daily,
    topProducts,
  };
}

export function mockVisitors(brandId, { from, to, productId, event, cursor } = {}) {
  const data = dataset(brandId);
  const all = data.items.filter((it) => {
    const day = dayKey(new Date(it.occurredAt));
    return inRange(day, from, to)
      && (!productId || it.product.shopifyProductId === String(productId))
      && (!event || it.event === event);
  });
  const offset = Math.max(0, parseInt(cursor, 10) || 0);
  const items = all.slice(offset, offset + PAGE_SIZE);
  const end = offset + items.length;
  return { items, nextCursor: end < all.length ? String(end) : null };
}

export function mockSettings(brandId, { status } = {}) {
  const next = rng(hash(`key:${brandId}`));
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let key = 'ofk_live_';
  for (let i = 0; i < 32; i += 1) key += alphabet[Math.floor(next() * alphabet.length)];
  const now = Date.now();
  if (status === 'not_configured') {
    return {
      key, allowedDomains: [], status: 'not_configured', lastSeenAt: null, seenDomains: [],
      tracking: { pixelStatus: 'not_configured', lastAddToCartAt: null, lastPurchaseAt: null, platformsSeen: [] },
    };
  }
  const seenDomains = [
    { domain: 'nova-atelier.myshopify.com', lastSeenAt: new Date(now - 4 * 60000).toISOString(), impressions7d: 2140 },
    { domain: 'www.novaatelier.hu', lastSeenAt: new Date(now - 3 * 3600000).toISOString(), impressions7d: 386 },
  ];
  return {
    key,
    allowedDomains: ['nova-atelier.myshopify.com', 'www.novaatelier.hu'],
    status: 'configured',
    lastSeenAt: seenDomains[0].lastSeenAt,
    seenDomains,
    tracking: {
      pixelStatus: 'configured',
      lastAddToCartAt: new Date(now - 26 * 60000).toISOString(),
      lastPurchaseAt: new Date(now - 5 * 3600000).toISOString(),
      platformsSeen: ['shopify'],
    },
  };
}
